var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.399,
    height: 15.746,
    viewBox: "0 0 14.399 15.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5716",
    "data-name": "Group 5716",
    transform: "translate(-21.336 -155.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5715",
    "data-name": "Group 5715",
    transform: "translate(21.336 155.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4666",
    "data-name": "Path 4666",
    d: "M228.3,53.187l-1.421-.752a.661.661,0,0,0-.619,0l-1.42.752a.5.5,0,0,1-.469,0l-1.42-.752a.661.661,0,0,0-.619,0l-1.421.752a.5.5,0,0,1-.466,0l-1.374-.714V62.9h7.159a.358.358,0,0,1,.358.358v2.239a1.776,1.776,0,1,0,3.552,0V52.474l-1.374.714A.5.5,0,0,1,228.3,53.187Zm-7.113,2.373h3.631a.358.358,0,0,1,0,.716h-3.631a.358.358,0,0,1,0-.716Zm6.5,5.552h-6.5a.358.358,0,0,1,0-.716h6.5a.358.358,0,1,1,0,.716Zm0-2.507h-6.5a.358.358,0,0,1,0-.716h6.5a.358.358,0,1,1,0,.716Z",
    transform: "translate(-215.739 -52.357)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4667",
    "data-name": "Path 4667",
    d: "M144.715,399.648h8.264a2.485,2.485,0,0,1-.746-1.776v-1.88h-9.294v1.88a1.778,1.778,0,0,0,1.776,1.776Z",
    transform: "translate(-142.939 -383.902)",
    fill: "#091b49"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1768",
    "data-name": "Rectangle 1768",
    width: 9.934,
    height: 1.987,
    transform: "translate(25.082 161.355)",
    fill: "#091b49"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.e05dfc0b44c943784379f702ef97d0b2.svg";
export { ForwardRef as ReactComponent };